import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { generatePath } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import { Box, CircularProgress } from '@mui/material';
import { useAuthState } from '../../stores/authStore';
import RouteConstants from '../../constants/routeConstants';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import { useEventState } from '../../stores/eventStore';
import {
    NO_ACCESS_PERMISSION,
    FULL_PERMISSION,
    REQUEST_STATUS_LIST
} from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import CommonRequests from '../../sharedcomponents/commonRequest/commonRequest';
//import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { HOTEL_ROOM_TAX } from '../../constants/Constant';
import { MODULE_LIST } from '../../constants/Constant';
import AppConstants from '../../constants/appConstants'
import AddCredentialDialog from './addCredentialDialog';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const Credential = () => {
    const showSearch = true;
    const eventInfo = Helper.getStorage('eventInfo');
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const agentConnection = Helper.getStorage('agentConnections') ? Helper.getStorage('agentConnections') : Helper.getSessionStorage('agentConnections');

    const eventModuleConfigInfo = Helper.getStorage('eventModuleConfig') ?? [];
    const hotelEventConfig =
        (eventModuleConfigInfo && eventModuleConfigInfo.moduleDetails) &&
        eventModuleConfigInfo.moduleDetails.filter(
            (key) =>
                key?.moduleName?.toLowerCase() ===
                MODULE_LIST[3].toLocaleLowerCase()
        );
    var hotelKeyValue =
        hotelEventConfig &&
        hotelEventConfig.reduce(
            (obj, item) => Object.assign(obj, { [item.key]: item.description }),
            {}
        );

    const eventState = useEventState();
    const history = useHistory();
    const authState = useAuthState();
    const loading = useState(false);
    const allData = useState();
    const allListData = useState([]);
    const eventData = useState(null);
    const userID = useState(null);
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    // const moduleIndex = useState(0)
    const [filters, setFilters] = React.useState(null);
    const statusList = useState(REQUEST_STATUS_LIST);
    const setAll = useState(false);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [modPermission, setModPermission] = React.useState(null);
    const [isParticipant, setIsParticipant] = React.useState(false);
    const [credData, setCredData] = React.useState(null);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });

    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [eventConfig, setEventConfig] = React.useState({
        allotted: 0,
        used: 0,
    });
    const [dropdownUsedCount, setDropdownUsedCount] = React.useState([])
    const [credentailDropdown,setCredentailDropdown] = React.useState()
    const addCredentialDialog = useState({
        open: false,
        title: '',
        message: '',
    });
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            !Helper.isAdminUser(userInfo) ||
            !Helper.isEventAdmin(userInfo) ||
            !Helper.isEventAgent(userInfo) ||
            !Helper.isEventStaff(userInfo)
        ) {
            setIsParticipant(true);
        } else {
            setIsParticipant(false);
        }
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        ) {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        ) {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() => {
        if (eventState.get() && eventState.eventDetail.get() != null) {
            const userInfo = Helper.getStorage('userInfo');
            if (!Helper.isAdminUser(userInfo)) {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                // console.log("permissions",permissions);
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, "CREDENTIAL")
                    );
                    // CREDENTIAL
                }
            } else if (Helper.isAdminUser(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
    }, [eventState]);

    useEffect(() => {
        if (modPermission && modPermission != NO_ACCESS_PERMISSION) {
            const pageInfo = pagingInfo.attach(Downgraded).get();
            if (pageInfo.itemsPerPage) {
                getAdminCredentialRequestList();
            }
        }
    }, [modPermission]);

    // useEffect(() => { 
    //     fetchEventDefaultConfig();
    // }, []);

    const fetchEventDefaultConfig = () => {
        ApiHelper.get(
            APIURLConstants.GET_CREDENTIAL_SETTING_BY_USERID(
                eventInfo.eventID,
                userInfo.userID
            )
        ).then((res) => {
            console.log("res",res);
            if (res.data) {
                const parseData = JSON.parse(res.data.setting);
                console.log(res.data,"parseData",parseData);
                
                if (parseData !== undefined && parseData.length > 0) {
                    const parseHotelSetting = JSON.parse(
                        parseData[0].TicketSetting
                    );
                    setCredentailDropdown(parseHotelSetting && parseHotelSetting.credential ? parseHotelSetting.credential : null)
                    setEventConfig({
                        allotted: parseHotelSetting && parseHotelSetting.credential ? Number(parseHotelSetting.credential) : 0,
                        used: 0,
                    })
                }
            }
        });
    };
    // console.log("eventConfig",eventConfig);
    const getRelationCounts = (data) => {
        return data.reduce((acc, item) => {
          acc[item.relation] = (acc[item.relation] || 0) + 1;
          return acc;
        }, {});
      };
    const getAdminCredentialRequestList = () => {
        let participantList = [];
        loading.set(true);
        ApiHelper.get(
            APIURLConstants.GET_CREDENTIALS(
                eventData.get().eventID,
                agentConnection ? false : userInfo.userType == 'Admin' ? true : false,
                userInfo.userID
            )
        )
            .then((res) => {
                if (res.data.rows) {
                    let data = res.data.rows;
                    let requestData = [];
                    if (data.length > 0) {
                        const getData = [getRelationCounts(data)]
                        // console.log("getData",getData,getData.length);
                        setDropdownUsedCount(getData)
                        
                        data.map((item) => {
                            if (
                                item.credentialSetting != undefined &&
                                item.credentialSetting.length > 0
                            ) {
                                const jsonD = JSON.parse(
                                    item.credentialSetting[0].setting
                                );
                                if (jsonD.length > 0) {
                                    const parseHotelSetting = JSON.parse(
                                        jsonD[0].CredentialSetting
                                    );
                                    setEventConfig({
                                        allotted: parseHotelSetting && parseHotelSetting.credential ? Number(parseHotelSetting.credential) : 0,
                                        used: item.credentialSetting && Number(
                                            item.credentialSetting[0].actualCredentialCount
                                        ),
                                    });
                                    setCredentailDropdown(parseHotelSetting && parseHotelSetting.credential ? parseHotelSetting.credential : null) 
                                }
                            }
                            if (
                                participantList.indexOf(item.participant) == -1
                            ) {
                                participantList.push(item.participant);
                            }
                            requestData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'Submitted By',
                                        key: 'createdBy',
                                        createdBy: item.createdByName,
                                        width: '0.20',
                                        inColumn: true,
                                    },
                                    {
                                        label: ' Name',
                                        key: 'name',
                                        name: item.contactName,
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Email',
                                        key: 'email',
                                        email: item.contactEmail,
                                        width: '0.15',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Phone',
                                        key: 'contactNo',
                                        contactNo: item.contactNo,
                                        width: '0.1',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Relation',
                                        key: 'relation',
                                        relation: item.relation,
                                        width: '0.1',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Family Relation',
                                        key: 'famRelation',
                                        famRelation: item.familyRelation,
                                        width: '0.1',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Status',
                                        key: 'requestStatus',
                                        requestStatus: item.requestStatus,
                                        width: '0.1',
                                        showStatusIcon: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'editnote',
                                        editnote: item.requestStatus != "Pending" ? item.note : "",
                                        width: '0.1',
                                    },
                                ],
                                selected: false,
                            });
                        });
                    } else {
                        fetchEventDefaultConfig()
                    }
                    setShowSearchRec(false);
                    allData.set(requestData);
                    allListData.set(requestData);
                    setFilters({
                        hotelName: participantList,
                        requestStatus: statusList.attach(Downgraded).get(),
                    });
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null) {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) => {
                loading.set(false);
                if (error.response && error.response.status === 401) {
                    alert(error);
                }
            });
    };

    // const handleConfirmation = () => {
    //     let deleteRequests = [];
    //     allData.get().map((row) => {
    //         if (row.selected === true) {
    //             deleteRequests.push(row.actualData.hotelBookID);
    //         }
    //     });

    //     ApiHelper.post(APIURLConstants.DELETE_HOTELBOOKING, {
    //         Ids: deleteRequests.join(','),
    //         SoftDelete: true,
    //         ModifiedBy: userID.value,
    //     })
    //         .then((res) => {
    //             if (res.data) {
    //                 setSnackBarProps({
    //                     ...snackBarProps,
    //                     openSnack: true,
    //                     variant: 'success',
    //                     message: 'Request deleted successfully',
    //                 });
    //                 //props.onDelete(false);
    //                 setAll.set(false);
    //                 getAdminCredentialRequestList();
    //                 //getEmailNotification();
    //             }
    //         })
    //         .catch((error) => {
    //             let message = '';
    //             if (error.response && error.response.status === 401) {
    //                 message = 'Access denied';
    //             } else {
    //                 message = 'Error while deleting request';
    //             }
    //             setSnackBarProps({
    //                 ...snackBarProps,
    //                 openSnack: true,
    //                 variant: 'error',
    //                 message: message,
    //             });
    //         });
    //     deleteConfirmation.set({
    //         open: false,
    //         title: '',
    //         OkButtonText: 'Ok',
    //         message: '',
    //     });
    // };
    // const handlePageChange = (event, page) => {
    //     pagingInfo.set({
    //         ...pagingInfo,
    //         currentPage: page,
    //         itemsPerPage: pagingInfo.get().itemsPerPage,
    //         noOfPages: pagingInfo.get().noOfPages,
    //     });
    //     getAdminCredentialRequestList();
    // };

    // const onActionClick = (index, action) => {
    //     let newData = [...allData.attach(Downgraded).get()];
    //     let newItem = newData[index];

    //     const isStatus = action == 'Approve' ? 2 : action == 'Reject' ? 3 : 1;
    //     requestNote.set({
    //         hotelBookID: newItem.actualData.hotelBookID,
    //         status: isStatus,
    //         userID: userID.get(),
    //         action,
    //         note: newItem.note,
    //     });
    //     openNoteDialog.set(true);
    // };

    //// After Completed New Request Page Then Un Commet
    const redirectToEditHotelRequest = (data) => {
        setCredData(data.actualData)
        setTimeout(() => {
            addCredentialDialog.set({
                open: true,
                title: '',
                OkButtonText: 'Update',
            });
        }, 500);
    };

    const CountNumberOfOccuranceOfString = (array, find) => {
        let count = 0;
        if (array && array.length > 0) {
            count = array.filter((obj) => obj.actualData.hotelRoomTax === find && obj.actualData.requestStatus !== 'To Do')
                .length;
        }
        return count;
    };

    const onAddRequest = () => {
        // const compCount = CountNumberOfOccuranceOfString(
        //     allData.attach(Downgraded).get(),
        //     HOTEL_ROOM_TAX[0]
        // );
        // const paidCount = CountNumberOfOccuranceOfString(
        //     allData.attach(Downgraded).get(),
        //     HOTEL_ROOM_TAX[1]
        // );

        // if (
        //     eventConfig.comp - compCount === 0 &&
        //     eventConfig.paid - paidCount === 0
        // ) {
        //     setSnackBarProps({
        //         ...snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'All rooms are occupied, you cannot add request.',
        //     });
        //     // return
        //9 }
        // if (eventConfig.allotted === 0) {
        //     setSnackBarProps({
        //         ...snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message: 'Please configure allotment.',
        //     });
        //     return
        // } else {
        //     if (eventConfig.allotted > eventConfig.used) {
        //         addCredentialDialog.set({
        //             open: true,
        //             title: '',
        //             OkButtonText: 'Submit',
        //         });
        //     } else {
        //         setSnackBarProps({
        //             ...snackBarProps,
        //             openSnack: true,
        //             variant: 'error',
        //             message: 'You have exceeded your allotment limits.',
        //         });
        //         return
        //     }
        // }
        addCredentialDialog.set({
            open: true,
            title: '',
            OkButtonText: 'Submit',
        });
    };
// console.log("addCredentialDialog",credData);

    // const onDelete = () => {
    //     const selected = allData.get().filter((user) => user.selected === true);
    //     if (selected.length === 0) {
    //         setSnackBarProps({
    //             ...snackBarProps,
    //             openSnack: true,
    //             variant: 'error',
    //             message: 'Please select request first',
    //         });
    //     } else {
    //         let message = setAll.get()
    //             ? 'Do you want to delete all request?'
    //             : 'Do you want to delete selected request?';

    //         deleteConfirmation.set({
    //             open: true,
    //             title: '',
    //             OkButtonText: 'Ok',
    //             message: message,
    //         });
    //     }
    // };


    // const editAllToggle = () => {
    //     setShowToggle(!showToggle);
    // };

    const validateUsedCount = (payload) => {
        // const getCred = credData && (credData !== null || credData !== undefined) ? credData.relation : null;
        // console.log("getCred",getCred);
        const getCred = credData?.relation ?? null;
        if (getCred !== payload) {           
            if (credentailDropdown === undefined || credentailDropdown == "") {
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: "error",
                    message: `Please configure allotment.`,
                });
                return false
            } else {
                let isValidCount = true;
                if(Array.isArray(credentailDropdown)){
                    const exceededLimit = credentailDropdown?.some((dropdown) =>
                        dropdownUsedCount?.some((usedCount) => {
                            if (usedCount[dropdown.name] >= dropdown.value && dropdown.name === payload) {
                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: true,
                                    variant: "error",
                                    message: `You have exceeded your ${payload} allotment limits.`,
                                });
                                return true; // Stops further checks
                            }
                            return false;
                        })
                    );
                    isValidCount = !exceededLimit;
                    return isValidCount;
                }else{
                   
                    const usedCountLen = Array.isArray(dropdownUsedCount) && dropdownUsedCount.length > 0 
                    ? Object.keys(dropdownUsedCount[0]).length 
                    : 0
                    console.log(credentailDropdown, dropdownUsedCount,usedCountLen);
                    if (usedCountLen >= credentailDropdown) {
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: "error",
                            message: `You have exceeded your allotment limits.`,
                        });
                        return false; // Stops further checks
                    }            
                }                
            }
        } else {
            return true
        }
    }
    // console.log(credentailDropdown,dropdownUsedCount);
    
    return (
        <Box sx={{ width: '100%' }}>
            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                <UnauthorizedUI showLogout={false} />
            ) : (
                <CommonRequests
                    // new props
                    data={allData.attach(Downgraded).get()}
                    editRow={redirectToEditHotelRequest}
                    showEdit={false}
                    showEditHotel={false}
                    //editAll={editAll}
                    handleClick={onAddRequest}
                    title={''}
                    // disableAdd={
                    //     allData.attach(Downgraded).length != 0 ? true : false
                    // }
                    // editButtonTitle={'Edit All'}
                    buttonTitle={'Add'}
                    // deleteRows={onDelete}
                    showSearch={showSearch}
                    searchLabel={'Search'}
                    showFilter={isParticipant ? false : true}
                    filters={filters}
                    showSearchRec={showSearchRec}
                    setShowSearchRec={setShowSearchRec}
                    // onActionClick={onActionClick}
                    getResults={getAdminCredentialRequestList}
                    pagingInfo={pagingInfo.attach(Downgraded).get()}
                    // handlePageChange={handlePageChange}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    moduleToShow={'Credential'}
                    moduleDisplayName={Helper.getModuleName(eventData.get() ? eventData.moduleDetails.get() : [],
                        AppConstants.EVENT_MODULES.CREDENTIAL)}
                    modPermission={modPermission}
                    hideDelete={true}
                    saveHotelButtonTitle={'Save'}
                    eventConfig={eventConfig}
                    endUserView={true}
                    credentailDropdown={credentailDropdown}
                    dropdownUsedCount={dropdownUsedCount}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {addCredentialDialog.get().open && 
                <AddCredentialDialog
                    open={addCredentialDialog.get().open}
                    message={addCredentialDialog.get().message}
                    OkButtonText={addCredentialDialog.get().OkButtonText}
                    handleCnfClick={() =>
                        handleLocationSubmit(addCredentialDialog)
                    }
                    credData={credData}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    // credentailDropdown={credentailDropdown}
                    // dropdownUsedCount={dropdownUsedCount}
                    // activityLocationErr={activityLocationErr}
                    // activityLocationChange={activityLocationChange}
                    onCancelClick={() => {
                        setCredData(null)
                        addCredentialDialog.set({
                            ...addCredentialDialog.get(),
                            open: false,
                        });
                    }}
                    validateUsedCount={validateUsedCount}
                    modPermission={modPermission}
                    getAdminCredentialsRequestList={getAdminCredentialRequestList}
                ></AddCredentialDialog>
            }
        </Box>
    );
};
export default {
    routeProps: {
        path: RouteConstants.CREDENTIALS,
        component: Credential,
    },
    name: 'Credentials',
};
